"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allForms = void 0;
const _allForms = require("./index");
exports.allForms = Object.values(_allForms)
    .filter((f) => Boolean(f))
    .map((form) => JSON.parse(JSON.stringify(form)));
